define('OutSystems/ReactWidgets/Button',["require", "exports", "tslib", "OutSystems/ClientRuntime/Settings", "OutSystems/ReactView/HtmlTags", "OutSystems/ReactView/Widget", "react"], function (require, exports, tslib_1, Settings_1, HtmlTags_1, Widget_1, React) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Button = void 0;
    var Button = (function (_super) {
        tslib_1.__extends(Button, _super);
        function Button() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Button.prototype.handleClick = function (event) {
            var _this = this;
            event.preventDefault();
            event.stopPropagation();
            var onClick = this.props.onClick;
            var onClickAction = function () { return onClick === null || onClick === void 0 ? void 0 : onClick(); };
            if (this.props.confirmationMessage && this.props.confirmationMessage.length) {
                var notification = navigator.notification;
                if (notification) {
                    notification.confirm(this.props.confirmationMessage, function (button) {
                        if (button === 1) {
                            _this.executeWithActiveClassOn(onClickAction);
                        }
                    }, "");
                }
                else if (window.confirm(this.props.confirmationMessage)) {
                    this.executeWithActiveClassOn(onClickAction);
                }
            }
            else {
                this.executeWithActiveClassOn(onClickAction);
            }
        };
        Button.prototype.render = function () {
            var _this = this;
            var buttonAttributes = tslib_1.__assign({ "data-button": "", className: this.props.style, type: this.props.isDefault ? "submit" : "button", disabled: !this.props.enabled, onClick: function (event) { return _this.handleClick(event); } }, ((0, Settings_1.getEnvParams)().EnableWCAG22 && { "data-wcag22": "" }));
            this.fillWithBuiltinProperties(buttonAttributes);
            return React.createElement(HtmlTags_1.HtmlTags.button, buttonAttributes, this.props.children);
        };
        Button = tslib_1.__decorate([
            Widget_1.WidgetSpec
        ], Button);
        return Button;
    }(Widget_1.Widget));
    exports.Button = Button;
});
//# sourceMappingURL=Button.js.map;
